export const CIQ_SHELL_EVENTS = {
  CLOSE_SHELL: 'ciq:closeShell',
  TOGGLE_SHELL_TAB: 'ciq:toggleShellTab',
  SHELL_STATE: 'ciq:shellState',
  REQUEST_SHELL_STATE: 'ciq:requestShellState',
  UPDATE_CONTEXT: 'ciq:updateContext',
  CLEAR_CONTEXT: 'ciq:clearContext',
  REGISTER_INSIGHTS_PROVIDER: 'ciq:registerInsightsProvider',
  UNREGISTER_INSIGHTS_PROVIDER: 'ciq:unregisterInsightsProvider',
} as const;
